import { NftActivities } from "@/app/(components)/Application/Nft/NftActivityDescription/types";
import { DEFAULT_PAGE_SIZE } from "@/shared/constants";
import config from "@shared/config/client";
import queryString from "query-string";
import { ICallableRequestBuilder } from "../requestBuilder/types";
import { Activity } from "./types";

const getNftItemActivities =
  (request: ICallableRequestBuilder<Activity[]>) => (nftId: string) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/activities/entity`,
      query: {
        nftId,
      },
    });

    return request.call(url);
  };

const getAllActivities =
  (request: ICallableRequestBuilder<Activity[]>) =>
  async (
    initiatorIds: string[] = [],
    activityTypes: NftActivities[] = [],
    nftContract: string | null = null,
    skip: number = 0,
    take: number = DEFAULT_PAGE_SIZE,
  ) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/activities`,
      query: {
        initiator: initiatorIds,
        type: activityTypes,
        nftContract,
        skip,
        take,
      },
    });

    return await request.call(url);
  };

const getPurchaseHistoryActivities =
  (request: ICallableRequestBuilder<Activity[]>) => async (nftId: string) => {
    return await request.call(
      `${config.apiUrl}/activities/price-history/${nftId}`,
    );
  };

const getReserveActivities =
  (request: ICallableRequestBuilder<Activity[]>) => (auctionId: string) => {
    return request.call(`${config.apiUrl}/activities/reserve/${auctionId}`);
  };

const requests = {
  getPurchaseHistoryActivities,
  getNftItemActivities,
  getAllActivities,
  getReserveActivities,
};

export default requests;
